/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ReferenceDot } from "recharts";
import ArrowLabel from "./ArrowLabel";

const Annotation = ({
  xLeft,
  xRight,
  y,
  chartWidth,
  textLabels,
  arrowLineWidth,
  bottomPadding,
  collisionXPos,
  arrowLineHeight,
  defaultPos = "left",
  disableDynamicPos,
  tooltipPayload,
  ...props
}) => {
  const [labelDims, setLabelDims] = useState({});
  const [labelPos, setLabelPos] = useState(defaultPos);
  const elLabel = useRef(null);

  // Get x pos
  let x;
  if (labelPos === "left") {
    x = xLeft;
  } else if (labelPos === "right") {
    x = xRight;
  }

  // Handle curve
  let curve = true;
  if (collisionXPos && collisionXPos > x) {
    curve = false;
  }

  useEffect(() => {
    // Flip label position if it will extend over chartWidth
    if (!disableDynamicPos) {
      if (labelDims.right + 20 > chartWidth) {
        setLabelPos("left");
      } else if (labelDims.left - 20 < 0) {
        setLabelPos("right");
      } else {
        setLabelPos(defaultPos);
      }
    }
  }, [defaultPos, labelDims, chartWidth, disableDynamicPos]);

  return (
    <ReferenceDot
      {...props}
      ifOverflow="extendDomain"
      ref={elLabel}
      x={x}
      y={y}
      r={1}
      fill={null}
      width={1}
      height={1}
      fillOpacity={0}
      label={{
        position: "right",
        content: (
          <ArrowLabel
            chartWidth={chartWidth}
            setLabelDims={setLabelDims}
            labelPos={labelPos}
            textLabels={textLabels}
            arrowLineWidth={arrowLineWidth}
            bottomPadding={bottomPadding}
            curve={curve}
            arrowLineHeight={arrowLineHeight}
            tooltipPayload={tooltipPayload}
          />
        ),
      }}
      stroke={null}
    />
  );
};

Annotation.defaultProps = {
  disableDynamicPos: false,
};

Annotation.propTypes = {
  xLeft: PropTypes.number.isRequired,
  xRight: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  chartWidth: PropTypes.number.isRequired,
  textLabels: PropTypes.arrayOf(PropTypes.any).isRequired,
  arrowLineWidth: PropTypes.number,
  bottomPadding: PropTypes.number,
  disableDynamicPos: PropTypes.bool, // if true, defaultPos will be kept
  collisionXPos: PropTypes.number,
  arrowLineHeight: PropTypes.number,
  tooltipPayload: PropTypes.node,
  defaultPos: PropTypes.string,
};

/** Hackish: We need to set these class properties in order to wrap ReCharts components,
 * see this github issue for more details: https://github.com/recharts/recharts/issues/412#issuecomment-472491968  */
Annotation.defaultProps = ReferenceDot.defaultProps;
Annotation.displayName = ReferenceDot.displayName;

export default Annotation;
